import { useState, useEffect } from "react";
import { useContract, useContractRead, useAddress, Web3Button } from "@thirdweb-dev/react";
import { ethers } from "ethers";
import "../styles/TokenSale.css";
import { CONTRACT_ADDRESSES } from "../contracts/addresses";

const TokenSale = () => {
  const [amount, setAmount] = useState(1);
  const [calculatedCost, setCalculatedCost] = useState("0");
  const address = useAddress();
  
  const contractAddress = CONTRACT_ADDRESSES.presale;
  const { contract } = useContract(contractAddress);
  
  const { data: tokenPrice } = useContractRead(contract, "tokenPrice");
  const { data: tokensAvailable } = useContractRead(contract, "tokensAvailable");
  const { data: saleStatus } = useContractRead(contract, "saleActive");

  // Calcular el costo cuando cambia el monto o el precio del token
  useEffect(() => {
    if (tokenPrice && amount) {
      const cost = ethers.BigNumber.from(tokenPrice).mul(amount);
      setCalculatedCost(ethers.utils.formatEther(cost));
    }
  }, [tokenPrice, amount]);

  return (
    <>
      <h2 className="text-content">Preventa de Tokens</h2>
      
      <section className="sale-intro text-content">
        <p>Bienvenido a la preventa oficial de tokens eDOP</p>
        <p>Participa en el futuro de las soluciones Layer 2 adquiriendo tokens eDOP durante nuestra fase de preventa.</p>
      </section>
      
      <div className="sale-info">
        <div className="info-card">
          <h3>Precio del Token</h3>
          <p>{tokenPrice ? ethers.utils.formatEther(tokenPrice) : "Cargando..."} ETH</p>
        </div>
        <div className="info-card">
          <h3>Tokens Disponibles</h3>
          <p>{tokensAvailable ? ethers.utils.formatUnits(tokensAvailable, 18) : "Cargando..."}</p>
        </div>
        <div className="info-card">
          <h3>Estado de la Venta</h3>
          <p className={saleStatus ? "active-sale" : "inactive-sale"}>
            {saleStatus ? "Activa" : "Inactiva"}
          </p>
        </div>
      </div>
      
      <div className="purchase-form">
        <h2>Comprar Tokens</h2>
        <div className="amount-input">
          <label htmlFor="amount">Cantidad</label>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            min="1"
          />
        </div>
        
        <div className="cost-display">
          <p>Coste total: <span>{calculatedCost}</span> ETH</p>
        </div>
        
        <Web3Button
          contractAddress={contractAddress}
          action={(contract) => {
            return contract.call(
              "buyTokens", 
              [ethers.utils.parseUnits(amount.toString(), 18)], 
              { value: ethers.utils.parseEther(calculatedCost) }
            )
          }}
          disabled={!saleStatus}
        >
          Comprar Tokens
        </Web3Button>
        
        {!saleStatus && (
          <p className="sale-notice">La venta está actualmente inactiva.</p>
        )}
      </div>
      
      <section className="token-details text-content">
        <h3>¿Por qué invertir en eDOP?</h3>
        <ul>
          <li><strong>Escalabilidad:</strong> Solución Layer 2 diseñada para manejar altos volúmenes de transacciones.</li>
          <li><strong>Bajas tarifas:</strong> Reduce significativamente el costo de gas para transacciones.</li>
          <li><strong>Ecosistema en crecimiento:</strong> Forma parte de un proyecto en continua expansión.</li>
          <li><strong>Programa de staking:</strong> Genera rendimiento pasivo al hacer staking de tus tokens.</li>
        </ul>
      </section>
    </>
  );
};

export default TokenSale;
